const ITEMS = [
  "PEMF",
  "Red Light",
  "Hyperbaric Oxygen",
  "Infinity Massage Chair",
  "Recovery Zone",
  "Herbal Teas",
];

export default function Marquee() {
  // Duplicate items so the loop is seamless
  const loop = [...ITEMS, ...ITEMS];

  return (
    <section
      data-testid="marquee-section"
      className="bg-sand border-y border-sand overflow-hidden"
      aria-label="Therapies"
    >
      <div className="mll-marquee py-8 sm:py-10">
        {loop.map((item, i) => (
          <div
            key={i}
            className="flex items-center gap-12 px-12 shrink-0"
          >
            <span className="font-serif italic text-stone/80 text-3xl sm:text-5xl whitespace-nowrap">
              {item}
            </span>
            <span
              aria-hidden="true"
              className="inline-block w-2 h-2 rounded-full bg-clay shrink-0"
            />
          </div>
        ))}
      </div>
    </section>
  );
}
